import * as React from 'react'

import { useAuthCtx } from '~logic/auth/AuthProvider'
import { getBaseHttpHeaders } from '~logic/graphQL/httpHeaders'

import { useLocaleCtx } from '../config/contexts/LocaleProvider'

/**
 * Returns a context object for useLazyQuery hook.
 * It contains headers with locale and authToken.
 *
 * There is an issue with the useLazyQuery hook from Apollo Client,
 * where useLazyQuery doesn't change refetch function when the apollo client instance of the ApolloProvider changes.
 * This is a workaround for that issue.
 *
 * for more info see {@link https://github.com/apollographql/apollo-client/issues/11096}
 *
 * TODO There is also a suggested way to solve this issue by not changing the client instance on every token or locale change.
 * The key is to use `setContext` link from Apollo Client and refs to update the headers.
 */
export const useLazyQueryContext = () => {
  const locale = useLocaleCtx()
  const { authToken } = useAuthCtx()

  const queryContext = React.useMemo(() => {
    return { headers: getBaseHttpHeaders({ locale, authToken }) }
  }, [authToken, locale])

  return queryContext
}
